import { render } from "./TopicTabs.vue?vue&type=template&id=32b5e0ec&scoped=true"
import script from "./TopicTabs.vue?vue&type=script&lang=js"
export * from "./TopicTabs.vue?vue&type=script&lang=js"

import "./TopicTabs.vue?vue&type=style&index=0&id=32b5e0ec&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b5e0ec"]])

export default __exports__